module.exports = __webpack_public_path__ + "img/find-car-5.e11ea092.png";